export const T = {
  en_GB: { noPlatforms: "None" },
  nb_NO: { noPlatforms: "Ingen" },
} as const;
